"use strict";

exports.__esModule = true;
exports.default = void 0;
var _vue = _interopRequireDefault(require("vue"));
var _merge = _interopRequireDefault(require("../../../lib/utils/merge"));
var _popupManager = _interopRequireDefault(require("../../../lib/utils/popup/popup-manager"));
exports.PopupManager = _popupManager.default;
var _scrollbarWidth = _interopRequireDefault(require("../scrollbar-width"));
var _dom = require("../dom");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
let idSeed = 1;
let scrollBarWidth;
var _default = exports.default = {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    openDelay: {},
    closeDelay: {},
    zIndex: {},
    modal: {
      type: Boolean,
      default: false
    },
    modalFade: {
      type: Boolean,
      default: true
    },
    modalClass: {},
    modalAppendToBody: {
      type: Boolean,
      default: false
    },
    lockScroll: {
      type: Boolean,
      default: true
    },
    closeOnPressEscape: {
      type: Boolean,
      default: false
    },
    closeOnClickModal: {
      type: Boolean,
      default: false
    }
  },
  beforeMount() {
    this._popupId = 'popup-' + idSeed++;
    _popupManager.default.register(this._popupId, this);
  },
  beforeDestroy() {
    _popupManager.default.deregister(this._popupId);
    _popupManager.default.closeModal(this._popupId);
    this.restoreBodyStyle();
  },
  data() {
    return {
      opened: false,
      bodyPaddingRight: null,
      computedBodyPaddingRight: 0,
      withoutHiddenClass: true,
      rendered: false
    };
  },
  watch: {
    visible(val) {
      if (val) {
        if (this._opening) return;
        if (!this.rendered) {
          this.rendered = true;
          _vue.default.nextTick(() => {
            this.open();
          });
        } else {
          this.open();
        }
      } else {
        this.close();
      }
    }
  },
  methods: {
    open(options) {
      if (!this.rendered) {
        this.rendered = true;
      }
      const props = (0, _merge.default)({}, this.$props || this, options);
      if (this._closeTimer) {
        clearTimeout(this._closeTimer);
        this._closeTimer = null;
      }
      clearTimeout(this._openTimer);
      const openDelay = Number(props.openDelay);
      if (openDelay > 0) {
        this._openTimer = setTimeout(() => {
          this._openTimer = null;
          this.doOpen(props);
        }, openDelay);
      } else {
        this.doOpen(props);
      }
    },
    doOpen(props) {
      if (this.$isServer) return;
      if (this.willOpen && !this.willOpen()) return;
      if (this.opened) return;
      this._opening = true;
      const dom = this.$el;
      const modal = props.modal;
      const zIndex = props.zIndex;
      if (zIndex) {
        _popupManager.default.zIndex = zIndex;
      }
      if (modal) {
        if (this._closing) {
          _popupManager.default.closeModal(this._popupId);
          this._closing = false;
        }
        _popupManager.default.openModal(this._popupId, _popupManager.default.nextZIndex(), this.modalAppendToBody ? undefined : dom, props.modalClass, props.modalFade);
        if (props.lockScroll) {
          this.withoutHiddenClass = !document.body.hasAttribute('data-el-popup-parent--hidden');
          if (this.withoutHiddenClass) {
            this.bodyPaddingRight = document.body.style.paddingRight;
            this.computedBodyPaddingRight = parseInt((0, _dom.getStyle)(document.body, 'paddingRight'), 10);
          }
          scrollBarWidth = (0, _scrollbarWidth.default)();
          let bodyHasOverflow = document.documentElement.clientHeight < document.body.scrollHeight;
          let bodyOverflowY = (0, _dom.getStyle)(document.body, 'overflowY');
          if (scrollBarWidth > 0 && (bodyHasOverflow || bodyOverflowY === 'scroll') && this.withoutHiddenClass) {
            document.body.style.paddingRight = this.computedBodyPaddingRight + scrollBarWidth + 'px';
          }
          document.body.setAttribute('data-el-popup-parent--hidden', '');
        }
      }
      requestAnimationFrame(() => {
        if (getComputedStyle(dom).position === 'static') {
          dom.style.position = 'absolute';
        }
        dom.style.zIndex = _popupManager.default.nextZIndex();
        this.opened = true;
        this.onOpen && this.onOpen();
        this.doAfterOpen();
      });
    },
    doAfterOpen() {
      this._opening = false;
    },
    close() {
      if (this.willClose && !this.willClose()) return;
      if (this._openTimer !== null) {
        clearTimeout(this._openTimer);
        this._openTimer = null;
      }
      clearTimeout(this._closeTimer);
      const closeDelay = Number(this.closeDelay);
      if (closeDelay > 0) {
        this._closeTimer = setTimeout(() => {
          this._closeTimer = null;
          this.doClose();
        }, closeDelay);
      } else {
        this.doClose();
      }
    },
    doClose() {
      this._closing = true;
      this.onClose && this.onClose();
      if (this.lockScroll) {
        setTimeout(this.restoreBodyStyle, 200);
      }
      this.opened = false;
      this.doAfterClose();
    },
    doAfterClose() {
      _popupManager.default.closeModal(this._popupId);
      this._closing = false;
    },
    restoreBodyStyle() {
      if (this.modal && this.withoutHiddenClass) {
        document.body.style.paddingRight = this.bodyPaddingRight;
        document.body.removeAttribute('data-el-popup-parent--hidden');
      }
      this.withoutHiddenClass = true;
    }
  }
};